import { HttpClient } from "@angular/common/http";
import { Injectable, signal } from "@angular/core";
import { catchError, Observable, of, tap } from "rxjs";

export interface Feature {
  id: number;
  name: string;
  included: boolean;
}

export interface PricingPlan {
  id: number;
  name: string;
  studentLimit: string;
  staffLimit: string;
  features: Feature[];
}

@Injectable({ providedIn: "root" })
export class FeatureService {
  private currentPlan = signal<PricingPlan | null>(null);

  constructor(private http: HttpClient) {
    const savedUser = sessionStorage.getItem("currentUser");
    if (savedUser) {
      try {
        const user = JSON.parse(savedUser);
        if (user.subscription && user.subscription.plan) {
          this.currentPlan.set(user.subscription.plan);
          console.log("Feature Plan restored from session");
        }
      } catch (e) {
        console.error("Failed to parse saved user for features", e);
      }
    }
  }

  setPlan(plan: any) {
    this.currentPlan.set(plan);

    localStorage.setItem("user_plan", JSON.stringify(plan));
  }

  // Check if feature exists and is set to true
  hasFeature(featureName: string): boolean {
    const plan = this.currentPlan();
    if (!plan) return false;

    return plan.features.some(
      (f) => f.name.toLowerCase() === featureName.toLowerCase() && f.included,
    );
  }

  getLimit(key: "studentLimit" | "staffLimit"): number {
    return parseInt(this.currentPlan()?.[key] || "0", 10);
  }

  isLocked(featureName: string): boolean {
    const plan = this.currentPlan();
    if (!plan) return true;

    // Find feature; if it's NOT included, it is "Locked"
    const feature = plan.features.find(
      (f: any) => f.name.toLowerCase() === featureName.toLowerCase(),
    );
    return feature ? !feature.included : true;
  }

  // refreshPlanFromServer(): Observable<any> {
  //   return this.http.get("/api/user/current-plan").pipe(
  //     tap((plan) => this.setPlan(plan)),
  //     catchError(() => of(null)),
  //   );
  // }
}
